import { isSupportedLocale } from '../../domain/i18n/locales';
import { readSetting, writeSetting } from '../../infrastructure/storage/localStore';

const LOCALE_SETTING_KEY = 'locale';

/** The locale the visitor last chose explicitly, or null if they never have. */
export function readStoredLocale() {
    const storedValue = readSetting(LOCALE_SETTING_KEY);

    return isSupportedLocale(storedValue) ? storedValue : null;
}

/**
 * Remember an explicit locale choice. Only ever called from the language
 * switcher — never from negotiation, or the first guess would harden into a
 * preference the visitor never made.
 */
export function writeStoredLocale(localeCode) {
    if (!isSupportedLocale(localeCode)) {
        return false;
    }

    return writeSetting(LOCALE_SETTING_KEY, localeCode);
}

export function readBrowserLanguages(navigatorObject = typeof navigator === 'undefined' ? null : navigator) {
    if (!navigatorObject) {
        return [];
    }

    if (Array.isArray(navigatorObject.languages) && navigatorObject.languages.length > 0) {
        return [...navigatorObject.languages];
    }

    return navigatorObject.language ? [navigatorObject.language] : [];
}
